import {Pipe, PipeTransform} from '@angular/core';
import {MatFormFieldAppearance} from '@angular/material/form-field';
import {FIELD_DESIGN_MODE} from '../../../shared/components/field-item/field-item.model';

@Pipe({
   name: 'appearance',
   standalone: false
})
export class AppearencePipe implements PipeTransform {

   transform (field_mode: string): MatFormFieldAppearance {
      return (field_mode && field_mode != "" && field_mode != "project.design.field_mode" ? Object.keys(FIELD_DESIGN_MODE)[Object.keys(FIELD_DESIGN_MODE).findIndex(elem => elem.toLowerCase() == FIELD_DESIGN_MODE[Number(field_mode) ?? 0].toLowerCase())].toLowerCase() : "") as MatFormFieldAppearance ;
   }

}
